import { Image } from 'components/Image'
import Row from 'components/Row.js'
import { View } from 'components/View'
import React from 'react'
import { DEVICE_PLATFORM } from 'utils/device/constants'
import AppStore from './download-on-the-app-store.svg'
import PlayStore from './get-it-on-google-play.svg'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'
import getStyleComponentUtil from 'modules/component/utils/get-style/index.js'
// import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
// import useSelector from 'modules/component/utils/hooks/useSelector.js'
// import openAndroidDownloadModalAction from 'modules/modal/actions/open-android-download'
// import { shouldUseApkSelector } from 'modules/consent/selectors/should-use-apk'

const PLATFORM_TO_URL = {
  [DEVICE_PLATFORM.APPLE]: 'https://itunes.apple.com/ca/app/gymaholic-training/id1409925959',
  [DEVICE_PLATFORM.ANDROID]: 'https://play.google.com/store/apps/details?id=com.gymaholic.training'
}

const ANALYTIC_EVENT = {
  DOWNLOAD_APP: 'DOWNLOAD_APP',
  DOWNLOAD_ON_APP_STORE_STORE: 'DOWNLOAD_ON_APP_STORE_STORE',
  DOWNLOAD_ON_PLAY_STORE: 'DOWNLOAD_ON_PLAY_STORE',
  DOWNLOAD_ON_PLAY_STORE_APK_MODAL: 'DOWNLOAD_ON_PLAY_STORE_APK_MODAL',
  DOWNLOAD_ON_PLAY_STORE_DIRECT: 'DOWNLOAD_ON_PLAY_STORE_DIRECT'
}

/**
 * @param props
 * @param props.appStoreHeight
 * @param props.playStoreHeight
 * @param props.style
 * @return {Element}
 * @constructor
 */
export function GetAppButton ({
  appStoreHeight = '3em',
  playStoreHeight = '3.2em',
  style
}) {
  // const dispatch = useDispatch()
  // const shouldUseApk = useSelector(shouldUseApkSelector)
  // const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  // const handleClickDownloadApp = () => {
  //   logEventAnalyticsUtil(ANALYTIC_EVENT.DOWNLOAD_APP)
  // }

  const handleClickDownloadAppStoreIcon = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.DOWNLOAD_ON_APP_STORE_STORE)
  }

  const handleClickDownloadPlayStoreIcon = (event) => {
    event.preventDefault()
    logEventAnalyticsUtil(ANALYTIC_EVENT.DOWNLOAD_ON_PLAY_STORE)

    // if (shouldUseApk) {
    //   // Show APK installation modal
    //   logEventAnalyticsUtil(ANALYTIC_EVENT.DOWNLOAD_ON_PLAY_STORE_APK_MODAL)
    //   dispatch(openAndroidDownloadModalAction())
    // } else {
    // Redirect to Play Store
    logEventAnalyticsUtil(ANALYTIC_EVENT.DOWNLOAD_ON_PLAY_STORE_DIRECT)
    window.location.href = PLATFORM_TO_URL[DEVICE_PLATFORM.ANDROID]
    // }
  }
  //
  // renderGetAppButton () {
  //   return (
  //     <ButtonPrimary
  //       url={PLATFORM_TO_URL[getPlatformDeviceUtil(this.props.userAgent)]}
  //       onClick={this.handleClickDownloadApp}
  //       style={{
  //         width: '100%'
  //       }}
  //     >
  //       {this.props.intl.formatMessage(messages.downloadApp)}
  //     </ButtonPrimary>
  //   )
  // }

  return (
    <Row
      style={getStyleComponentUtil({
        alignItems: View.ALIGN.CENTER,
        justifyContent: View.JUSTIFY.CENTER,
        width: '100%',
        maxWidth: '300px'
      }, style)}
    >
      <View>
        <a
          target='_blank'
          rel='noopener noreferrer'
          onClick={handleClickDownloadAppStoreIcon}
          href={PLATFORM_TO_URL[DEVICE_PLATFORM.APPLE]}
        >
          <Image
            src={AppStore}
            alt='App store badge'
            hasNoAspectRatio
            style={{
              minHeight: 'auto',
              height: appStoreHeight
            }}
          />
        </a>
      </View>
      <View
        ml
      >
        <a
          onClick={handleClickDownloadPlayStoreIcon}
          href='#'
        >
          <Image
            src={PlayStore}
            alt='Google play badge'
            hasNoAspectRatio
            style={{
              minHeight: 'auto',
              height: playStoreHeight
            }}
          />
        </a>
      </View>
    </Row>
  )
}
